import React from 'react';
import { ResponsiveChartContainer, BarPlot, LinePlot, BarSeriesType, ChartsLegend, ChartsXAxis, ChartsYAxis, ChartsTooltip } from '@mui/x-charts';
import { Box } from '@mui/material';

import { LineSeriesType } from '@mui/x-charts';

interface MinimalHandicapChartProps {
    ejemplares: string[];
    predValues: number[];
    rankingScores: number[];
}

const MinimalHandicapChart: React.FC<MinimalHandicapChartProps> = ({ ejemplares, predValues, rankingScores }) => {
    const series: (BarSeriesType | LineSeriesType)[] = [
        {
            data: predValues,
            label: 'Predicción (%)',
            type: 'bar',
            color: '#6366F1',
            yAxisKey: 'predYAxis',
        },
        {
            data: rankingScores,
            label: 'Ranking Score',
            type: 'line',
            color: '#FF5733',
            yAxisKey: 'rankingYAxis',
        },
    ];

    

    return (
        <Box sx={{ width: '100%', height: 400 }}>
            <ResponsiveChartContainer
                xAxis={[{ scaleType: 'band', data: ejemplares, label: 'Ejemplares' }]} // Asegúrate de que 'ejemplares' sea un array de strings
                yAxis={[
                    {
                        id: 'predYAxis',
                        scaleType: 'linear',
                        label: 'Predicción (%)',
                    },
                    {
                        id: 'rankingYAxis',
                        scaleType: 'linear',
                        label: 'Ranking Score',
                        position: 'right',
                    },
                ]}
                series={series}
                height={400}
                margin={{ left: 70, right: 70, top: 50, bottom: 70 }}
            >
                <ChartsXAxis />
                <ChartsYAxis axisId='predYAxis' />
                <ChartsYAxis axisId='rankingYAxis' position='right' />
                <BarPlot />
                <LinePlot />
                <ChartsLegend />
                <ChartsTooltip />
            </ResponsiveChartContainer>
        </Box>
    );
};

export default MinimalHandicapChart;